<!-- @format -->
<template>
    <div v-if="isShowStandardSub || isGiftSub" class="na-ad-box-dock has-text-centered">
        <img
            v-if="isGiftSub"
            class="is-clickable"
            :src="imageUrl('KWGiftSubs-Ad-250.png')"
            alt="Give the gift of local news!"
            title="Gift the gift of local news!"
            width="250"
            height="250"
            loading="lazy"
            @click="clicked"
        />
        <img
            v-if="!isGiftSub && isShowStandardSub"
            class="is-clickable is-hidden-tablet"
            :src="imageUrl('HouseAd-SubscribeToKW.png')"
            alt="Subscribe to the Kingston Wire"
            title="Subscribe to the Kingston Wire"
            width="250"
            height="250"
            loading="lazy"
            @click="clicked"
        />
        <img
            v-if="!isGiftSub && isShowStandardSub"
            class="is-clickable is-hidden-mobile"
            :src="imageUrl('HouseAd-SubscribeToKW.png')"
            alt="Subscribe to the Kingston Wire"
            title="Subscribe to the Kingston Wire"
            width="250"
            height="250"
            loading="lazy"
            @click="clicked"
        />
    </div>
</template>

<script>
import { mediaMixin } from '@/mixins/MediaMixin.js';

export default {
    mixins: [mediaMixin],

    data() {
        return {
            isGiftSub: false,
            isShowStandardSub: true
        };
    },

    methods: {
        /**
         * Ad clicked
         */
        clicked() {
            if (this.isGiftSub) {
                this.$router.push({ name: 'gift-subscription', params: { slug: 'kingston-wire' } });
            } else {
                this.$router.push({ name: 'kwsubscribe' });
            }
        }
    }
};
</script>
